var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-content-box global-content-flex"},[_c('y-menu-title'),_c('div',{staticClass:"global-mb16"},[_c('y-form',{attrs:{"formInfo":_vm.formInfo},on:{"search":_vm.search}})],1),_c('div',{staticClass:"global-felx-1"},[_c('y-table',{attrs:{"tableData":_vm.tableData,"tooltip-effect":"dark","loading":_vm.talbeLoading,"tableInfo":_vm.tableInfo,"pageInfo":{
        pageNum: _vm.formDataList.pageNum,
        pageSize: _vm.formDataList.pageSize,
        total: _vm.total,
      }},on:{"handlePage":_vm.handlePage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }